import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const sponsors = [{
  name: "Apex Financial",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1557866/img/logo_apex_financial.png"
}, {
  name: "Summit Health",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1557866/img/logo_summit_health.png"
}, {
  name: "Global Ventures",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1557866/img/logo_global_ventures.png"
}, {
  name: "Urban Development",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1557866/img/logo_urban_development.png"
}, {
  name: "Tech Horizon",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1557866/img/logo_tech_horizon.png"
}, {
  name: "Civic Partners",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1557866/img/logo_civic_partners.png"
}, {
  name: "Elevate Energy",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1557866/img/logo_elevate_energy.png"
}, {
  name: "Metro Arts",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1557866/img/logo_metro_arts.png"
}, {
  name: "Pioneer Systems",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1557866/img/logo_pioneer_systems.png"
}, {
  name: "Golden State Bank",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1557866/img/logo_golden_state_bank.png"
}, {
  name: "Silverline Media",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1557866/img/logo_silverline_media.png"
}, {
  name: "NextGen Auto",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1557866/img/logo_nextgen_auto.png"
}];
export default function CorporateAllies() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="corporate-allies" className="dark bg-background text-foreground py-24 px-6 lg:px-8 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-20">
        <div className="absolute top-[-10%] right-[-5%] w-96 h-96 bg-primary/20 rounded-full blur-3xl" />
        <div className="absolute bottom-[-10%] left-[-5%] w-96 h-96 bg-secondary/10 rounded-full blur-3xl" />
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div ref={ref} className={cn("text-center mb-16 transition-all duration-1000 transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
          <h2 className="text-primary font-sans text-sm md:text-base font-bold tracking-[0.2em] uppercase mb-4">
            Distinguished Partners
          </h2>
          <div className="h-0.5 w-24 bg-primary/30 mx-auto" />
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 md:gap-12 items-center justify-items-center">
          {sponsors.map((sponsor, i) => <div key={i} data-index={i} className={cn("group w-full flex items-center justify-center p-4 transition-all duration-700 delay-[calc(var(--index)*50ms)]", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")} style={{
          "--index": i
        } as React.CSSProperties}>
              <div className="relative w-full max-w-[160px] aspect-[3/2] flex items-center justify-center">
                <img src={sponsor.logo} alt={`${sponsor.name} logo`} className="max-w-full max-h-full object-contain transition-all duration-500 
                           filter grayscale opacity-60 
                           group-hover:grayscale-0 group-hover:opacity-100 
                           group-hover:drop-shadow-[0_0_15px_var(--color-primary)]" />
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}